// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpFtPdarmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpFtPdarmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpFtPdarmgrIconOutlined = function DrrpFtPdarmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpFtPdarmgrIconOutlinedSvg
  }));
};

DrrpFtPdarmgrIconOutlined.displayName = 'DrrpFtPdarmgrIconOutlined';
export default React.forwardRef(DrrpFtPdarmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpFtPdarmgrIconOutlined.js
// module id = 2568
// module chunks = 0